import request from 'src/api'
import { addToast } from 'src/toasts'
import { lockButton } from 'src/lockButton'
import { handleErrors } from 'src/errors'
import { contractPeopleFunctions } from 'packs/contract_people/functions'
import initDatatableChrome from 'src/datatableChrome'

export default () => {
  contractPeopleFunctions()

	// datatable init
  let contractPeopleDatatable = $('#contract-people-datatable').DataTable({
    "language": {
      url: "/datatable_i18n"
    },
    "pageLength": (localStorage.getItem('contractPeopleIndexPageLength') || 25),
    "processing": true,
    "responsive": true,
    "serverSide": true,
    "ajax": {
      "url": $('#contract-people-datatable').data('source')
    },
    "columns": [
      { "data": "first_name" },
      { "data": "last_name" },
      { "data": "phone" },
      { "data": "customers" }
    ],
    initComplete(settings, json) {
      initDatatableChrome('contract-people-datatable')
  	}
  })

  // T-102: claim the shared refresh hook. `false` keeps the current page and ordering — a save changes
  // one row, so resetting paging would throw the user back to page 1.
  // T-104: the `getElementById` check makes this order-free — after a Turbolinks visit the old
  // element is gone from the document, so a stale claim returns instead of reloading a detached table.
  window.refreshIndexTable = function() {
    if (!document.getElementById('contract-people-datatable')) return
    contractPeopleDatatable.ajax.reload(null, false)
  }

  $('#content').on('change', "[name='contract-people-datatable_length']", function() {
    localStorage.setItem('contractPeopleIndexPageLength', $(this).val())
  })

  $('.clear-button').on('click', function() {
    $('.clear-button').addClass('d-none')
    contractPeopleDatatable.search('').draw()
  })

  $('#content').on('click', '#add_contract_person', function() {
    lockButton('#add_contract_person')
    offcanvasRight.show()
    $.getScript('/contract_people/new')
  })

  $('#mainModal').on('click', '#confirmDelete', function(event) {
    $(this).blur()
    if ($("#basic-information").find('form').attr('action').includes('contract_people')) {
      lockButton('#confirmDelete')

      request.delete($("#offcanvasRight .tab-pane.active form").attr('action'))
        .set('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'))
        .accept('json')
        .then(res => {
          addToast(res.body.success, 'notice')
          // F-148: the record is gone, so there is nothing unsaved to protect. Must be cleared BEFORE the
          // close below — `hide.bs.offcanvas` reads `dirty` and `hidden.bs.offcanvas` only clears it after,
          // so an edited-then-deleted record raised "you have unsaved changes" on top of the success toast.
          dirty = false
          if (contractPeopleDatatable !== null) {
            contractPeopleDatatable.ajax.reload()
          }
          mainModal.hide()
          $('#offcanvasRight .btn-close').click()
        })
        .catch(err => {
          handleErrors(err, '#confirmDelete')
        })
    }
  })
}
